<div class="contenedor-resumen-pago">
  <label class="contenedor-resumen-pago__poliza"
    >Información de pago Póliza # {{ referencia }}
  </label>
  <ul class="contenedor-resumen-pago__list">
    <li *ngFor="let resumenDePago of resumenesDePago">
      {{ resumenDePago.key }}:
      {{
        resumenDePago.key === KEY_VALOR
          ? (resumenDePago.value | currency: 'COP':'symbol-narrow':'0.0-0')
          : resumenDePago.value
      }}
    </li>
  </ul>
</div>
